export class CacheController {
  private cache: { [key: string]: any } = {};

  set(key: string, data: any): void {
    this.cache[key] = data;
  }

  get<T>(key: string): T | null {
    return this.cache[key] || null;
  }

  has(key: string): boolean {
    return Boolean(this.cache[key]);
  }
}
